// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Time Picker Popup Component */
.hide {
  display: none;
}

@media all and (max-width: 1440px) {
  .hide-xxl-down {
    display: none;
  }
}

@media all and (min-width: 1440px) {
  .hide-xxl-up {
    display: none;
  }
}

@media all and (max-width: 1280px) {
  .hide-xl-down {
    display: none;
  }
}

@media all and (min-width: 1280px) {
  .hide-xl-up {
    display: none;
  }
}

@media all and (max-width: 1024px) {
  .hide-lg-down {
    display: none;
  }
}

@media all and (min-width: 1024px) {
  .hide-lg-up {
    display: none;
  }
}

@media all and (max-width: 840px) {
  .hide-md-down {
    display: none;
  }
}

@media all and (min-width: 840px) {
  .hide-md-up {
    display: none;
  }
}

@media all and (max-width: 600px) {
  .hide-sm-down {
    display: none;
  }
}

@media all and (min-width: 600px) {
  .hide-sm-up {
    display: none;
  }
}

@media all and (max-width: 320px) {
  .hide-xs-down {
    display: none;
  }
}

@media all and (min-width: 320px) {
  .hide-xs-up {
    display: none;
  }
}

ids-popup[visible][animated] {
  transition: none;
}

:host([hidden]) {
  display: none;
}

.ids-time-picker-popup::part(popup) {
  padding-block: var(--ids-space-none);
  background-color: var(--ids-time-picker-popup-color-background);
}
.ids-time-picker-popup .popup-btn {
  align-items: center;
  border-top: 1px solid var(--ids-time-picker-popup-button-color-border);
  width: 100%;
}
.ids-time-picker-popup .popup-btn::part(button) {
  height: 100%;
  color: var(--ids-time-picker-popup-button-color-text-default);
  padding: var(--ids-space-none);
  padding-block: var(--ids-space-12);
  align-items: center;
  justify-content: center;
}
.ids-time-picker-popup .popup-btn::part(button):hover {
  color: var(--ids-time-picker-popup-button-color-text-hover);
}
.ids-time-picker-popup ids-dropdown::part(trigger-field) {
  display: inline-flex;
  min-width: 75px;
}
.ids-time-picker-popup ids-list-box,
.ids-time-picker-popup ids-list-box-option {
  width: 100%;
}
.ids-time-picker-popup ids-list-box-option {
  padding-left: 4px;
}
.ids-time-picker-popup ids-popup::part(popup) {
  margin: var(--ids-space-none);
  padding: var(--ids-space-none);
}
.ids-time-picker-popup .dropdowns {
  display: flex;
  flex-direction: row;
  padding-inline-start: 15px;
  padding-inline-end: 15px;
  padding-top: 15px;
}
.ids-time-picker-popup .dropdown::part(trigger-field) {
  justify-content: center;
}
.ids-time-picker-popup .separator {
  width: 12px;
  display: inline-block;
  height: 38px;
  margin-top: 23px;
}
.ids-time-picker-popup .separator.colons {
  color: var(--ids-time-picker-popup-colons-color-text);
  width: 17px;
  text-align: center;
  font-size: 16px;
  font-weight: 400;
  line-height: 38px;
}
@media all and (max-width: 320px) {
  .ids-time-picker-popup .dropdowns {
    flex-direction: column;
    align-items: center;
    width: var(--ids-input-width-20);
  }
  .ids-time-picker-popup .separator {
    display: none;
  }
}

.ids-time-picker-popup[dir=rtl] ids-list-box-option {
  padding-right: 4px;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-time-picker/ids-time-picker-popup.scss","webpack://./src/themes/mixins/ids-hide-mixin.scss"],"names":[],"mappings":"AAAA,oCAAA;ACGA;EACE,aAAA;ADDF;;ACKE;EADF;IAEI,aAAA;EDDF;AACF;;ACWE;EADF;IAEI,aAAA;EDPF;AACF;;ACiBE;EADF;IAEI,aAAA;EDbF;AACF;;ACuBE;EADF;IAEI,aAAA;EDnBF;AACF;;AC6BE;EADF;IAEI,aAAA;EDzBF;AACF;;ACmCE;EADF;IAEI,aAAA;ED/BF;AACF;;ACyCE;EADF;IAEI,aAAA;EDrCF;AACF;;AC+CE;EADF;IAEI,aAAA;ED3CF;AACF;;ACqDE;EADF;IAEI,aAAA;EDjDF;AACF;;AC2DE;EADF;IAEI,aAAA;EDvDF;AACF;;ACiEE;EADF;IAEI,aAAA;ED7DF;AACF;;ACuEE;EADF;IAEI,aAAA;EDnEF;AACF;;AAvEA;EACE,gBAAA;AA0EF;;AAvEA;EACE,aAAA;AA0EF;;AAtEE;EACE,oCAAA;EACA,+DAAA;AAyEJ;AAtEE;EACE,mBAAA;EACA,sEAAA;EACA,WAAA;AAwEJ;AAtEI;EACE,YAAA;EACA,6DAAA;EACA,8BAAA;EACA,kCAAA;EACA,mBAAA;EACA,uBAAA;AAwEN;AArEI;EACE,2DAAA;AAuEN;AAlEI;EACE,oBAAA;EACA,eAAA;AAoEN;AAhEE;;EAEE,WAAA;AAkEJ;AA/DE;EACE,iBAAA;AAiEJ;AA7DI;EACE,6BAAA;EACA,8BAAA;AA+DN;AA3DE;EACE,aAAA;EACA,mBAAA;EACA,0BAAA;EACA,wBAAA;EACA,iBAAA;AA6DJ;AA1DE;EACE,uBAAA;AA4DJ;AAzDE;EACE,WAAA;EACA,qBAAA;EACA,YAAA;EACA,gBAAA;AA2DJ;AAzDI;EACE,qDAAA;EACA,WAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AA2DN;ACSE;ED/DE;IACE,sBAAA;IACA,mBAAA;IACA,gCAAA;EAyDJ;EAtDE;IACE,aAAA;EAwDJ;AACF;;AAlDE;EACE,kBAAA;AAqDJ","sourcesContent":["/* Ids Time Picker Popup Component */\n@use '../../themes/mixins/ids-hide-mixin' as *;\n\n// Remove left/top transforms from animation on this component's popup\nids-popup[visible][animated] {\n  transition: none;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n.ids-time-picker-popup {\n  &::part(popup) {\n    padding-block: var(--ids-space-none);\n    background-color: var(--ids-time-picker-popup-color-background);\n  }\n\n  .popup-btn {\n    align-items: center;\n    border-top: 1px solid var(--ids-time-picker-popup-button-color-border);\n    width: 100%;\n\n    &::part(button) {\n      height: 100%;\n      color: var(--ids-time-picker-popup-button-color-text-default);\n      padding: var(--ids-space-none);\n      padding-block: var(--ids-space-12);\n      align-items: center;\n      justify-content: center;\n    }\n\n    &::part(button):hover {\n      color: var(--ids-time-picker-popup-button-color-text-hover);\n    }\n  }\n\n  ids-dropdown {\n    &::part(trigger-field) {\n      display: inline-flex;\n      min-width: 75px;\n    }\n  }\n\n  ids-list-box,\n  ids-list-box-option {\n    width: 100%;\n  }\n\n  ids-list-box-option {\n    padding-left: 4px;\n  }\n\n  ids-popup {\n    &::part(popup) {\n      margin: var(--ids-space-none);\n      padding: var(--ids-space-none);\n    }\n  }\n\n  .dropdowns {\n    display: flex;\n    flex-direction: row;\n    padding-inline-start: 15px;\n    padding-inline-end: 15px;\n    padding-top: 15px;\n  }\n\n  .dropdown::part(trigger-field) {\n    justify-content: center;\n  }\n\n  .separator {\n    width: 12px;\n    display: inline-block;\n    height: 38px;\n    margin-top: 23px;\n\n    &.colons {\n      color: var(--ids-time-picker-popup-colons-color-text);\n      width: 17px;\n      text-align: center;\n      font-size: 16px;\n      font-weight: 400;\n      line-height: 38px;\n    }\n  }\n\n  @include breakpoint-xs-down {\n    .dropdowns {\n      flex-direction: column;\n      align-items: center;\n      width: var(--ids-input-width-20);\n    }\n\n    .separator {\n      display: none;\n    }\n  }\n}\n\n// RTL\n.ids-time-picker-popup[dir='rtl'] {\n  ids-list-box-option {\n    padding-right: 4px;\n  }\n}\n","@use '../../themes/mixins/ids-core-mixins' as *;\n\n// Includes Hidden Classes and Mixins for hiding elements at breakpoints\n.hide {\n  display: none;\n}\n\n.hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-down {\n  @media all and (max-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n@mixin hide-xxl-up {\n  @media all and (min-width: $breakpoint-xxl) {\n    display: none;\n  }\n}\n\n.hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-down {\n  @media all and (max-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n@mixin hide-xl-up {\n  @media all and (min-width: $breakpoint-xl) {\n    display: none;\n  }\n}\n\n.hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-down {\n  @media all and (max-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n@mixin hide-lg-up {\n  @media all and (min-width: $breakpoint-lg) {\n    display: none;\n  }\n}\n\n.hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-down {\n  @media all and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n@mixin hide-md-up {\n  @media all and (min-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-down {\n  @media all and (max-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n@mixin hide-sm-up {\n  @media all and (min-width: $breakpoint-sm) {\n    display: none;\n  }\n}\n\n.hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n.hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin hide-xs-up {\n  @media all and (min-width: $breakpoint-xs) {\n    display: none;\n  }\n}\n\n@mixin breakpoint-xs-down {\n  @media all and (max-width: $breakpoint-xs) {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
